import { gql, useQuery } from '@apollo/client';

export function GetPumpWatersState() {
  const {
    data = {},
    loading,
    error,
  } = useQuery(GET_PUMPWATERSBYCUSTOMER, {
    pollInterval: 5000, // 5 segundos
    fetchPolicy: 'network-only', // Siempre trae la información más reciente
  });

  return { loading, data: data.WaterPumpsByCustomerActive || [], error };
}

const GET_PUMPWATERSBYCUSTOMER = gql`
  query WaterPumpsByCustomerActive {
    WaterPumpsByCustomerActive {
      _id
      name
      code
      customerId
      active
      power_status
      location
      deviceId
      device {
        name
        current_status
      }
    }
  }
`;
